import React, { useState, useRef, useEffect } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import Icon from "components/Elements/Icon/Icon.tsx";

const FormBuilderTypeDropdown = ({
  tempField,
  setTempField,
  setfieldChanged,
  setUpdateToggle,
}) => {
  const { getTextByKey } = useContent();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const options = tempField.fields.optionsValue;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (value) => {
    setTempField({
      ...tempField,
      fields: {
        ...tempField.fields,
        recipientType: value,
      },
    });
    setfieldChanged(true);
    setUpdateToggle(true);
    setIsOpen(false);
  };

  const getCurrentLabel = () => {
    const currentOption = options.find(
      (opt) => opt.option === tempField.fields.recipientType
    );
    return getTextByKey(currentOption.label);
  };

  return (
    <div className="recipient-type-dropdown input-part" ref={dropdownRef}>
      <div className="custom-select">
        <div
          className={`select-header ${isOpen ? "open" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span>{getCurrentLabel()}</span>
          <Icon
            name="newinbox/arrow_down"
            iconClass={`${isOpen ? "" : "arrow-close-dropdown-icon"}`}
          />
        </div>
        {isOpen && (
          <div className="select-options">
            {options.map((option) => (
              <div
                key={option.option}
                className={`select-option ${
                  tempField.fields.recipientType === option.option
                    ? "selected"
                    : ""
                }`}
                onClick={() => handleSelect(option.option)}
              >
                {getTextByKey(option.label)}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FormBuilderTypeDropdown;
